// 用户角色
export const ROLE = {
  SPEAKER: 1, // 主讲
  LISTENER: 2, // 听课
  STUDENT: 3, // 学生
  SHARE_SCREEN: 99 // 共享屏幕, 服务端没有共享屏幕role,此为前端维护字段
}